import NewsArchivePage from "features/Dashboard/pages/NewsArchivePage.tsx";
import { ProtectedRoute } from "./ProtectedRoute";

export const NewsArchiveRoutes = ProtectedRoute({
	path: "news-archive",
	element: <NewsArchivePage />
});
